/** Звук монеты: короткий, синтезированный, без файлов.
 *
 * Файл пришлось бы грузить и кэшировать; две ноты из осциллятора весят ноль и
 * звучат мгновенно. Звук зовётся только из жеста (покупка, выигрыш) — иначе
 * браузер его и не пропустит.
 *
 * Ошибки глотаются целиком: звук — приправа, и падать из-за него нельзя.
 */

let ctx: AudioContext | null = null;

function ensure(): AudioContext | null {
  try {
    if (!ctx) {
      const Ctor =
        window.AudioContext ??
        (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
      if (!Ctor) return null;
      ctx = new Ctor();
    }
    if (ctx.state === 'suspended') void ctx.resume();
    return ctx;
  } catch {
    return null;
  }
}

function tone(at: number, freq: number, duration: number, gain: number) {
  const audio = ensure();
  if (!audio) return;
  try {
    const osc = audio.createOscillator();
    const amp = audio.createGain();
    // Синус с лёгкой примесью третьей гармоники звучит «монетно», не пища
    osc.type = 'triangle';
    osc.frequency.value = freq;
    const start = audio.currentTime + at;
    amp.gain.setValueAtTime(0.0001, start);
    amp.gain.exponentialRampToValueAtTime(gain, start + 0.012);
    amp.gain.exponentialRampToValueAtTime(0.0001, start + duration);
    osc.connect(amp).connect(audio.destination);
    osc.start(start);
    osc.stop(start + duration + 0.05);
  } catch {
    /* без звука — тоже нормально */
  }
}

/** Дзынь покупки: две ноты вверх, как монета о монету. */
export function chime(): void {
  tone(0, 1245, 0.16, 0.08);
  tone(0.07, 1865, 0.22, 0.07);
}

/** Фанфара выигрыша: короткое арпеджио вверх. */
export function jingle(): void {
  tone(0, 784, 0.14, 0.07);
  tone(0.09, 988, 0.14, 0.07);
  tone(0.18, 1319, 0.3, 0.08);
}

/** Щелчок язычка о барьер колеса: короткий и сухой, как трещотка. */
export function tick(): void {
  tone(0, 2100, 0.035, 0.035);
}

/** Стук барабана о стопор: низкий и короткий. */
export function thud(): void {
  tone(0, 180, 0.09, 0.1);
  tone(0, 320, 0.05, 0.05);
}
